import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Project as ApiProject } from 'api/project';
import { ProjectsStore, Project } from './store';

export const slice = createSlice({
  name: '@@PROJECTS',
  initialState: ProjectsStore.empty(),
  reducers: {
    load: (state: ProjectsStore) => ProjectsStore.load()(state),
    updated: (
      state: ProjectsStore,
      { payload: project }: PayloadAction<Project>,
    ) => ProjectsStore.updated(project)(state),
    putAll: (
      state: ProjectsStore,
      { payload: projects }: PayloadAction<ApiProject[]>,
    ) => ProjectsStore.putAll(projects)(),
  },
});
